import {Component, inject, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-bookings-form',
    templateUrl: './bookings-form.component.html',
    styleUrls: ['./bookings-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingsFormComponent implements OnInit {
  data = '';

  private fb = inject(FormBuilder);
  form: FormGroup;

  constructor(private router:Router, private activatedRoute: ActivatedRoute, private sanitizer: DomSanitizer) {
    this.form = this.fb.group({
      recaptchaReactive: ['', Validators.required]
    });
  }

  ngOnInit() {

    this.data = this.activatedRoute.snapshot.params.linkId.toLowerCase();
    console.log(this.data);// OUTPUT 1534

  }

  captchaActive(): boolean {
    return this.form.get('recaptchaReactive').value;
  }
}
